import gql from 'graphql-tag'

export const GET_MESSAGES_MONGO = gql`
    query {
        messagesMongo {
            _id
            titulo
            mensagem
            visualizado            
        }
    }
`

export const CHECK_NEW_MESSAGES_MONGO = gql`
    query {
        checkNewMessagesMongo
    }
`
